import { useRouter } from 'next/router';
import { FC } from 'react';
import { extractTranslation } from '../../../helpers/formatters';
import { QuestionProps } from '../../../pages/form';

export const InfoTextQuestion: FC<QuestionProps> = ({ question }) => {
  const locale = useRouter().locale;

  const subtitle = extractTranslation(question?.subtitle, locale);
  const subtitleHtml = extractTranslation(question?.subtitleHtml, locale);

  return subtitle ? (
    <div>{subtitle}</div>
  ) : subtitleHtml ? (
    <span dangerouslySetInnerHTML={{ __html: subtitleHtml }} />
  ) : null;
};
